import apiClient from "./ApiClient";

export const getApi = async (url) => {
  return apiClient.get(url);
};

export const postApi = async (url, data, options) => {
  return apiClient.post(url, data, options);
};
